import { Dispatch } from 'redux';
import { GETRegistroDocumentDownloadLink } from 'requests/registro';
import { typedAction } from 'store/modules/base';

export interface RegistroApiState {
  getRegistroDocumentDownloadLink(dispatch: Dispatch, documentId: string, stackRequest?: boolean): Promise<string>;
}

const registroApiInicialState: RegistroApiState = {
  getRegistroDocumentDownloadLink: GETRegistroDocumentDownloadLink,
};

enum RegistroApiActionType {
  Update = 'registroApi/UPDATE',
  Reset = 'registroApi/RESET',
}

export const updateRegistroApi = (state: RegistroApiState) => {
  return typedAction(RegistroApiActionType.Update, state);
};

export const resetRegistroApi = () => {
  return typedAction(RegistroApiActionType.Reset);
};

type RegistroApiAction = ReturnType<typeof updateRegistroApi | typeof resetRegistroApi>;

export function registroApiReducer(
  state: RegistroApiState = registroApiInicialState,
  action: RegistroApiAction
): RegistroApiState {
  switch (action.type) {
    case RegistroApiActionType.Update:
      return { ...action.payload };
    case RegistroApiActionType.Reset:
      return { ...registroApiInicialState };
    default:
      return state;
  }
}
